import {useState} from 'react'
import http from '@/biz/http.mjs'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import Table from '@/components/Table/Table.jsx'
import runAsync from '@/script/runAsync.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'

export const readDefaultPromptTemplate = async (usageScenarioCode, prjId) => {
    return http.get(
        '/prjDefaultAssistant/onePrjDefaultAssistant',
        {prjId, usageScenarioCode}
    )
}

export const readLastPromptTemplate = async usageScenarioCode => {
    return http.get(
        '/userLatestUsedAssistant/oneUserLatestUsedAssistant',
        {usageScenarioCode}
    )
}

export const readPromptTemplates = async (scene, prjId, extra) => {
    const templates = await http.get(
        '/llmPromptTemplate/listEnableLlmPromptTemplate',
        {prjId, usageScenarioCode: scene, ...extra}
    )

    return templates.map(({llmPromptTemplateItems, ...data}) => ({
        ...data,
        $id: crypto.randomUUID(),

        llmPromptTemplateItems: llmPromptTemplateItems.map(
            ({modelInfomationConfig, ...data}) => ({
                ...data,

                modelInfomationConfig: modelInfomationConfig ?
                    JSON.parse(modelInfomationConfig) : []
            })
        ),
    }))
}

export const useDefaultPromptTemplate = (scene, prjId) => useSwrNoCache(
    () => readDefaultPromptTemplate(scene, prjId),

    {
        dependencies: [prjId, scene],

        start: (
            void 0 !== prjId &&
            void 0 !== scene
        ),
    },
)

export const useLastPromptTemplate = scene => useSwrNoCache(
    () => readLastPromptTemplate(scene),

    {
        dependencies: [scene],
        start: void 0 !== scene,
    },
)

export const usePromptTemplates = (scene, prjId, extra) => useSwrNoCache(
    () => runAsync(
        () => readPromptTemplates(scene, prjId, extra),
        {action: '读取模板'},
    ),

    {
        dependencies: [prjId, scene],

        start: (
            //void 0 !== prjId &&
            void 0 !== scene
        ),
    },
)

const TableTemplates = ({extra, prjId, scene, onChange, ...props}) => {
    const {data, isLoading} = usePromptTemplates(scene, prjId, extra)

    const columns = [
        {
            title: 'AI助手',
            dataIndex: 'promptTemplateName',
            dataType: 'text',
        },
        {
            title: '模型',
            dataIndex: 'llmName',
            dataType: 'text',
        },
        {
            title: '算力平台',
            dataIndex: 'llmProviderName',
            dataType: 'text',
        },
    ]

    if (/^CODE_REVERSE_ENGINEERING_(BDLOGIC|UI)_V2$/.test(scene)) {
        columns.push({
            title: 'API标记方式',
            dataIndex: 'apiMarkMethodName',
            dataType: 'text',
            width: 120,
        })
    }
    else if (/^GENERATE_UV(_CODE)?$/.test(scene)) {
        columns.push({
            title: '界面布局类型',
            dataIndex: 'uiLayoutTypeName',
            dataType: 'text',
            width: 120,
        })
    }

    const rowSelection = {
        defaultSelectFirst: true,
        onChange: (_, selectedRows) => onChange(selectedRows),
        type: 'radio',
    }

    return (
        <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            rowSelection={rowSelection}
            selectRowOnClick
            {...props}
        />
    )
}

const ModalChooseTemplate = ({extra, prjId, scene, onOk, ...props}) => {
    const [template, setTemplate] = useState()
    const okButtonProps = {disabled: ! template}
    const onTableChange = rows => setTemplate(rows[0])
    const _onOk = () => onOk(template)

    return (
        <Modal
            okButtonProps={okButtonProps}
            title="选择AI助手"
            width={1200}
            onOk={_onOk}
            {...props}
        >
            <TableTemplates
                extra={extra}
                prjId={prjId}
                scene={scene}
                onChange={onTableChange}
            />
        </Modal>
    )
}

export const updateLastPromptTemplate = async template => {
    const {
        llmId,
        pkid: promptTemplateId,
        usageScenarioCode,
    } = template

    return http.post(
        '/userLatestUsedAssistant/saveUserLatestUsedAssistant',
        {llmId, promptTemplateId, usageScenarioCode}
    )
}

export const useChoosePromptTemplate = () => {
    const openModal = useOpenModal()

    return (scene, prjId, extra) => openModal(
        <ModalChooseTemplate
            extra={extra}
            prjId={prjId}
            scene={scene}
        />
    )
}
